import React from 'react';
import { Box, BoxProps, CircularProgress, makeStyles } from '@material-ui/core';
import { primaryGreen } from 'src/data/colors';

const useStyles = makeStyles(() => ({
  progress: {
    color: primaryGreen,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));

export interface LoadingInlineProps extends BoxProps {
  text?: React.ReactNode;
  size?: number;
}

const LoadingInline = ({ text, size = 16, ...boxProps }: LoadingInlineProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.container} {...boxProps}>
      <CircularProgress size={size} className={classes.progress} />
      {text && <span>{text}</span>}
    </Box>
  );
};

export default LoadingInline;
